/*
 * Menu state
 * ==========
 *
 * A simple menu
 */

export default class Menu extends Phaser.State {

  create() {

    this.game.stage.backgroundColor = '#ffffff';

    this.debug = false;

    this.i96 = {
      buttonHover: false
    }

    var title = this.add.image(90, 20, 'title');
    title.scale.setTo(0.45);

    // cursors = game.input.keyboard.createCursorKeys();
    this.game.input.keyboard.addCallbacks(this, null, null, this._keyPress);


    // BUTTONS
    this.i96.buttons = [];
    // this.addDiffButton(0);
    // this.addDiffButton(1);
    // this.addDiffButton(2);

    // this.addButton(100, 570, 'logoLars', 'http://www.ermert.es');
    // this.addButton(374, 570, 'logoMusic', 'https://circusmarcus.bandcamp.com/');
    // this.addButton(700, 540, 'logoFoya', 'http://foyaland.com');

    this.game.input.onDown.add(this._clickDone, this);

  }

  addButton(x, y, imageID, url) {
    var db = this.add.image(x, y, imageID);
    db.inputEnabled = true;

    var that = this;
    db.events.onInputUp.add(function () {
      that.setCursor('default');
      var lru = url;
      window.open(lru,'_blank');
    });

    this.i96.buttons.push(db);
  }

  addDiffButton(no) {
    var db = this.add.image(288+no*120, 504, 'buttonDiff');
    db.inputEnabled = true;
    var crop = new Phaser.Rectangle(96*no, 0, 96, 58);
    db.crop( crop );

    var that = this;
    db.events.onInputUp.add(function () {
      var thet = that;
      var nu = no;
      thet.game.i96.diff = nu;
      thet._start();
    });

    this.i96.buttons.push(db);
  }

  setCursor(type) {
    document.getElementsByTagName('canvas')[0].style.cursor = type;
  }
  updateCursor() {
    if (this.i96.buttonHover === true) {
      this.setCursor('pointer');
      this.i96.buttonHover = false;
    } else if (this.i96.buttonHover === false) {
      this.setCursor('default');
      this.i96.buttonHover = null;
    }
  }

  update() {
    // if (this.startButton2.input.pointerOver())
    // {
    //   this.startButton2.alpha = 1;
    //   document.getElementsByTagName('canvas')[0].style.cursor = 'pointer';
    // }
    // else
    // {
    //   this.startButton2.alpha = 0.5;
    //   document.getElementsByTagName('canvas')[0].style.cursor = 'default';
    // }

    this.updateCursor();

    for ( var button of this.i96.buttons ) {
      if (button.input.pointerOver()) {
        button.alpha = 1;
        this.i96.buttonHover = true;
      }
      else {
        button.alpha = 0.5;
      }
    }


    if (typeof this.emitter !== 'undefined') {
      this.emitter.customSort(this.scaleSort, this);

      this.emitter.forEachAlive(function(bubble) {
        if (bubble.y < 0) {
          bubble.kill();
        }
      });
    }

  }

  render() {
    if (typeof this.emitter !== 'undefined')
      this.game.debug.text( this.emitter.total, 32, 32);
  }

  scaleSort(a, b) {

    if (a.scale.x < b.scale.x)
    {
      return -1;
    }
    else if (a.scale.x > b.scale.x)
    {
      return 1;
    }
    else
    {
      return 0;
    }

  }

  //  TOOL FUNCTION
  // ==============================================

  _start() {
    this.game.state.start('Game');
  }


  _keyPress(char) {
    this._start();
  }

  _clickDone(pointer) {
    this._start();
    return;
    if (this.debug) {
      console.log('ee');
      console.log(pointer.position);


      //	Emitters have a center point and a width/height, which extends from their center point to the left/right and up/down
      this.emitter = this.game.add.emitter(0, 0, 200);

      //	This emitter will have a width of 800px, so a particle can emit from anywhere in the range emitter.x += emitter.width / 2
      // emitter.width = 800;

      this.emitter.makeParticles('bubbleParticle', 0, 30);

      // emitter.minParticleSpeed.set(0, 300);
      // emitter.maxParticleSpeed.set(0, 600);

      this.emitter.setRotation(0, 0);
      this.emitter.setAlpha(0.01, 0.25, 800, Phaser.Easing.Quintic.InOut, true);
      this.emitter.setScale(0.1, 0.5, 0.1, 0.5, 1000, Phaser.Easing.Quintic.Out);
      this.emitter.gravity.set(0, -150);

      this.emitter.x = pointer.position.x;
      this.emitter.y = pointer.position.y;

      //  The first parameter sets the effect to "explode" which means all particles are emitted at once
      //  The second gives each particle a 2000ms lifespan
      //  The third is ignored when using burst/explode mode
      //  The final parameter (10) is how many particles will be emitted in this single burst
      this.emitter.start(true, 4000, null, 10);
      // this.emitter.start(false, 500, 10);


      // this.game.add.tween( this.emitter ).to( { emitX: 800 }, 2000, Phaser.Easing.Linear.None, true, 0, Number.MAX_VALUE, true);
    }
  }
}
